import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export interface FilterData {
  filter: string;
  AdvanceSearch: any;
  Type: string;
  RequestType: string;
}

@Component({
  selector: 'app-nav-corporatedecision',
  templateUrl: './nav-corporatedecision.component.html',
  styleUrls: ['./nav-corporatedecision.component.css'],
  standalone: false
})
export class NavCorporatedecisionComponent implements OnInit {
  master: any;
  url: string;
  pageurl: string;
  TypeHeader: string;
  MsgType: number;
  DisplayMessage: string;
  FormSearchNoticePlan: FormGroup;
  ReportType: string;
  pageNumber: number;
  RightsID: string;
  advanceSearchValue: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  RequestFrom: string;
  selectedAll: any;
  isSelected: boolean[];
  skeletonRows = Array(10).fill(0);
  filteredData: any[] = [];
  private searchSubject = new Subject<string>();
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder,private route : ActivatedRoute) {
    this.initSearch();
    this.url = AppComponent.baseURL;
  }

  ngOnInit() {
    this.isSelected = [];
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202038001') || this.RightsID.includes('202038021') || this.RightsID.includes('202038000')) {
    } else {
      window.location.href = "module/0";
    }
    this.pageNumber = 1;
    this.MsgType = 1; // Loading

    this.route.params.subscribe(params => {
      this.pageurl = this.router.url;
      let pagehead = this.pageurl.split('/');
      this.ReportType = pagehead[2];
      this.FetchCase(pagehead[2], '');
      this.advanceSearchValue = "";
      this.RequestFrom = pagehead[4];
      if (this.ReportType == 'plan') {
        this.TypeHeader = "List of Processed Decision";
      } else {
        this.TypeHeader = "List of Pending Decision To be Process";
      }
    })

    this.FormSearchNoticePlan = this.formBuilder.group({
      txtSearch: ['']
    });
  }
  OpenModal(url, cID, modelName, urld) {
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
    if (modelName == "Filter") {
      window.addEventListener("message", this.receiveMessage, false);
      this.modalURL = "filter/202038000";
    }
  }
  receiveMessage(event) {
    if (event?.data?.data?.Param != null) {
      localStorage.setItem('advancesearch', event.data.data.Param);
      let element: HTMLElement;
      element = document.getElementsByClassName('close')[0] as HTMLElement;
      element.click();
    }
  }
  ReturnAdvanceSearch() {
    if (localStorage.getItem('advancesearch') != "") {
      this.advanceSearchValue = JSON.parse(localStorage.getItem('advancesearch'));
    }
    localStorage.setItem('advancesearch', "");
    this.FetchCase(this.ReportType, '');
  }
  onSearchNoticePlan(SearchData) {
    this.FetchCase(this.ReportType, SearchData.txtSearch);
  }
  FetchCase(type, filter) {
    let filterData: FilterData = {
      filter: filter,
      AdvanceSearch: this.advanceSearchValue,
      Type: type,
      RequestType: this.RequestFrom
    };
    this.http.post(this.url + 'CorporateDecision/Search_Notice_Plan', filterData)
      .subscribe((data) => {
        if (data == null || data.toString() == "[]") {
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
          this.master = null;
          this.filteredData = [];
        } else {
          this.MsgType = 0; // No Message
          this.master = JSON.parse(data.toString());
          this.totalRecords = this.master.length;
          this.filteredData = [...this.master];
        }
      },
        (error) => {
          this.MsgType = 3; // Error Message
          this.DisplayMessage = error.message;
        }
      );
  }
  getColumnCount() {
    return this.ReportType == 'plan' ? 12 : 10;
  }
  onSearch(value) {
    this.searchSubject.next(value.trim().toLowerCase());
  }
  initSearch() {
    this.searchSubject
      .pipe(
        debounceTime(300),       
        distinctUntilChanged()
      )
      .subscribe(searchText => {
        this.filterTable(searchText);
      });
  }
  filterTable(searchText: string) {
    if (!searchText) {
      this.filteredData = [...this.master];
      return;
    }

    this.filteredData = this.master.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
    this.pageNumber = 1;
  }
  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filterTable('')
  }
}